module.exports = __webpack_public_path__ + "static/media/IMG_5342-min.cbd0376b.JPG";